
import React from "react";
import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function PorQue2026Section() {
  return (
    <PostSection id="por-que-2026" title="Por qué 2026 es el año en que esto se vuelve serio">
      <p className="text-gray-300 mb-6">
        El vibe coding no es nuevo como concepto — llevamos años con GitHub Copilot y asistentes de código. Lo que ha cambiado en 2026 es la calidad y la accesibilidad.
      </p>

      <h3 id="modelos-ia" className="text-xl font-semibold text-white mt-8 mb-4">
        Evolución de los modelos de IA
      </h3>
      <p className="text-gray-300 mb-4">
        Modelos como Claude Sonnet, GPT-4o y Gemini 1.5 han alcanzado un nivel de comprensión del código que hace un año era impensable. Ya no generan fragmentos sueltos que tienes que ensamblar tú. Generan aplicaciones completas con base de datos, autenticación, lógica de negocio y diseño coherente, a partir de una descripción en lenguaje natural.
      </p>
      <p className="text-gray-300 mb-6">
        Al mismo tiempo han emergido herramientas específicamente diseñadas para el vibe coding que abstraen toda la complejidad técnica. Lovable, Bolt, Cursor, v0 de Vercel. Cada una con su enfoque, pero todas orientadas al mismo objetivo: que cualquier persona con una idea pueda construirla.
      </p>

      <h3 id="coste-producto" className="text-xl font-semibold text-white mt-8 mb-4">
        Caída del coste de lanzamiento
      </h3>
      <PostHighlight>
        <p className="text-gray-300">
          Lo que antes requería 30.000€ y 6 meses hoy puede costar 100€ al mes en herramientas y llevarse a cabo en semanas. El coste de lanzar un producto digital ha caído en un orden de magnitud.
        </p>
      </PostHighlight>
    </PostSection>
  );
}
